var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"no-select"},_vm.$listeners),[_c('svg',{attrs:{"viewBox":"0 0 64 64","width":_vm.size,"height":_vm.size}},[_c('use',{attrs:{"xlink:href":_vm.spritepath,"fill":_vm.color}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }